import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import AdminLogin from '../views/AdminLogin.vue';
import Admin from '../views/Admin.vue';
import PhotoGallery from '../views/PhotoGallery.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/photos',
      name: 'photos',
      component: PhotoGallery
    },
    {
      path: '/tools',
      name: 'tools',
      component: () => import('../views/Tools.vue')
    },
    {
      path: '/hot',
      name: 'hot',
      component: () => import('../views/HotRank.vue')
    },
    {
      path: '/links',
      name: 'links',
      component: () => import('../views/BookmarkLinks.vue')
    },
    {
      path: '/admin/login',
      name: 'adminLogin',
      component: AdminLogin
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/anime/:id',
      name: 'animeDetail',
      component: () => import('../views/AnimeDetail.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/anime',
      name: 'animeAdmin',
      component: () => import('../views/AnimeAdmin.vue'),
      meta: { requiresAdmin: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin && !localStorage.getItem('adminToken')) {
    next('/admin/login');
    return;
  }
  next();
});

export default router;
